// eslint-disable-next-line
export default {
  id: 'batata_doce_ninja',
  type: 'ninja',
  title: "Batata Doce ou comum (Ninja's Version)",
  ingredients: [
    '? batata doce ou comum',
    '? sal',
    '? pimenta do reino',
    '? paprika',
  ],
  parts: [
    {
      title: "Batata doce ou comum (Ninja's Version)",
      methodOfPreparation: [
        'Tempere a batata com todos os temperos',
        'Deixe um tempo para pegar o gosto',
        'Coloque na air fryer em 180 graus por 20 minutos',
      ],
    },
  ],
};
